import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import image
import genomicsLogo from "../../image/Logo_genom.svg";
import bannerImg from "../../image/health/woman-interacting-with-dna.jpg";
import bannervideo from "../../image/health/freepik__white-clean-background-a-high-tech-dna-shape-in-bl__95498.mp4";
import getstartImage from "../../image/health/Get start.svg"
import dotsImage from "../../image/drugomics/3dots.svg";

// import data
import contentData from "../../data/content/health/healthContent.json";
import { DataStructure } from "../../types";
// import components
import { NavTree } from "../navigation/NavLinkPages";
import { MainFrame, Col2ContentFrame, Col3ContentFrame, SpacingFrame } from "../display/Frame";
import { BannerSection, BusinessBannerSection, BannerVideoSection, StepSectionWithTools,ImageTextWithSteps,ThreeStepsWithArrows } from "../display/Sections";
import { ImageImport } from "../display/ImageFormat";
import { TextBody, TitleSubtitle } from "../display/TextFormat";
import { AtomToolsOverview } from "../content/ToolsOverview";
import NoContent, { LoadingContent } from "../content/NoContent";
// import functions
import { DisplayInfo2Cols, DisplayProductCards } from "../../functions/DisplayInfoFunctions";
// import context
import { useLang } from "../Context";
// import global var
import { typedVocab } from "../GlobalVar";
import navUnitsData from "../../data/navUnits.json";

// import icons
import { Rocket, Send } from "lucide-react";

const typedNavUnitsData : DataStructure = navUnitsData;

const typedContent : DataStructure = contentData;
const imagePath = "image/health/";

interface DefaultBannerProps {
    title: string;
    subtitle: string;
};
export function DefaultBanner({ title, subtitle } : DefaultBannerProps) {
    return (
        <BannerSection image={bannerImg} title={ title } subtitle={ subtitle } />
    )
};


export default function Health() {
    const { lang } = useLang();
    const data = typedContent["Health"];
    const section1 = data[1];
    const section2 = data[2];
    const section3 = data[3];
    const section4 = data[4];
    const section5 = data[5];
    const section6 = data[6];
    const section7 = data[7];
    const contentData = data["content"];

    //section 4
    const backgrounds = [
        require("../../image/health/3d-representation-dna.jpg"),
        require("../../image/health/medical-capsule-with-medical-concept-3d-rendering.jpg"),
        require("../../image/health/image.png"),
      ];
      
      const steps = Object.keys(section4).filter((key) => key !== "title");

    //section6
    const parseSteps = Object.keys(section6["steps"]).map((key) => {
        const step = section6["steps"][key];
        return {
          number: step.number,
          subtitle: step.subtitle[lang],
          text: step.text[lang]
        };
      });
    

    //section 7
    const parsedSteps = Object.keys(section7["steps"]).map((key) => ({
        imageSrc: section7["steps"][key]["imageSrc"],
        title: section7["steps"][key]["title"][lang],
        text: section7["steps"][key]["text"][lang]
      }));
    

    return (
        <>
            {/* <BusinessBannerSection 
                bgImage={ bannerImg }
                logoImage={ genomicsLogo }
                title={ data["title"][lang] }
                subtitle={ data["subtitle"][lang] }
            /> */}

                <BannerVideoSection
                videoSrc={bannervideo}
                title={ data["title"][lang] }
                subtitle={ data["subtitle"][lang] }
                buttonLabel=""
                buttonLink=""
                darkMode
                playbackRate={0.5} 
                />

            <NavTree />
{/* 
            <MainFrame>
                <SpacingFrame>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <Col3ContentFrame>
                        <DisplayProductCards data={ section1["solutions"] } />
                    </Col3ContentFrame>
                </SpacingFrame>
            </MainFrame>


            <AtomToolsOverview isScroll />

            <MainFrame>
                <DisplayInfo2Cols contentData={contentData} imagePath={imagePath} />
            </MainFrame> */}

            <MainFrame smallerPadding>
            <div className=" rounded-3xl px-12 py-12" style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <DisplayInfo2Cols contentData={section2} imagePath={imagePath} pt={0} pb={0}/>
            </div>
            </MainFrame>


            <DisplayInfo2Cols contentData={section3} imagePath={imagePath} smallerPadding/>

            {/* section7 */}
            <MainFrame smallerPadding>
            <div className="flex flex-col-reverse lg:flex-row items-start gap-8 mb-16">
                <div className="w-full lg:w-1/3">
                <img src={dotsImage} alt="" />
                </div>

                <div className="w-full lg:w-2/3">
                <TitleSubtitle title={section7["title"][lang]} right />
                </div>
            </div>

            <ThreeStepsWithArrows steps={parsedSteps} />
            </MainFrame>



            <MainFrame pt={128} pb={64}>
            <div className="w-full">
                <TitleSubtitle title={section4["title"][lang]} left />

                {/* Step 1 */}
                <div
                className="rounded-3xl"
                style={{
                    backgroundImage: `url(${backgrounds[0]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
                >
                <StepSectionWithTools
                    title={section4[0]["title"][lang]}
                    label={section4[0]["label"][lang]}
                    text={section4[0]["text"][lang]}
                    tools={section4[0]["tools"]}
                />
                </div>

                <p className="text-xl font-semibold text-left">
                <span style={{ color: "#D89669" }}>---</span>
                </p>


                {/* Step 2 */}
                <div
                className="rounded-3xl"
                style={{
                    backgroundImage: `url(${backgrounds[1]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
                >
                <StepSectionWithTools
                    title={section4[1]["title"][lang]}
                    label={section4[1]["label"][lang]}
                    text={section4[1]["text"][lang]}
                    tools={section4[1]["tools"]}
                    reverse
                />
                </div>

                <p className="text-xl font-semibold text-right">
                <span style={{ color: "#988CE3" }}>---</span>
                </p>

                {/* Step 3 */}
                <div
                className="rounded-3xl"
                style={{
                    backgroundImage: `url(${backgrounds[2]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
                >
                <StepSectionWithTools
                    title={section4[2]["title"][lang]}
                    label={section4[2]["label"][lang]}
                    text={section4[2]["text"][lang]}
                    tools={section4[2]["tools"]}
                />
                </div>

                <p className="text-xl font-semibold text-left">
                <span style={{ color: "#57C4CB" }}>---</span>
                </p>

            </div>
            </MainFrame>
            


            <MainFrame smallerPadding>
            <ImageTextWithSteps
                title={section6["title"][lang]}
                imagePaths={section6["imagePaths"]}
                steps={parseSteps}
            />
            </MainFrame>



            <MainFrame pt={64} pb={128}>
            <div
                className="rounded-3xl"
                style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}
            >
                <div className="flex flex-col px-6 lg:px-12 py-12">
               
                <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
                  
                    <div className="w-full lg:w-1/2 flex flex-col gap-6">
                    <div className="flex items-center gap-2">
                        <Rocket className="w-10 h-10 lg:w-5 lg:h-5 my-auto" />
                        <p className="text-left text-[20px]">{section5["Join Us 1"][lang]}</p>
                    </div>

                    <p className="text-left text-[32px] font-semibold whitespace-pre-line">
                        {section5["Join Us 2"][lang]}
                    </p>
                    </div>

                  
                    <div className="w-full lg:w-1/2 flex justify-center">
                    <img src={getstartImage} alt="" />
                    </div>
                </div>

              
                <div className="flex justify-center lg:justify-start mt-10 mb-2">
                    <button className="group w-fit rounded-3xl px-16 py-1 border-2 border-grey-500 text-white bg-grey-500 hover:text-teal-300">
                                <a className="flex items-center justify-center gap-2" href={`mailto:${typedNavUnitsData["Company_Email"][lang]}`}>
                                    <p className="text-white group-hover:text-teal-300">{ typedVocab["Contact Us"][lang] }</p>
                                    <Send size={16} />
                                </a>
                    </button>
                    </div>
                </div>
            </div>
            </MainFrame>

            
 

        </>
    )
};

export function HealthSubpages() {
    const { lang } = useLang();
    const { healthSolutions } = useParams();

    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<DataStructure | undefined>(undefined);
    const [contentData, setContentData] = useState<DataStructure | undefined>(undefined);

    useEffect(() => {
        if (healthSolutions) {
            // Assume typedToolsContent is defined and imported correctly
            setData(typedContent[healthSolutions] || undefined);
        };
    }, [healthSolutions]);

    useEffect(() => {
        if (data) {
            setContentData(data["content"] || undefined);
            setLoading(false);
        } else {
            setLoading(false);
        };
    }, [data]);

    if (loading) {
        return <LoadingContent />
    };

    if (!data) {
        return <NoContent />
    };

    return (
        <>
            <DefaultBanner title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            <NavTree />
            { contentData && <DisplayInfo2Cols contentData={contentData} imagePath={imagePath} /> }
        </>
    )
};